module.exports = "pegasus/assets/twitter.png";